<template>
  <VBtn :class="[btnClass, absolutePosition]"
        v-bind="$attrs"
        :tag="btnTag"
        :href="href"
        :icon="isIcon"
        class="mobile-button"
        large
        flat
        type="button"
        v-on ="$listeners">
    <span class="btn-content">
      <span class="main-content">
        <slot />
      </span>
      <span class="sub-text">
        <slot name="sub"/>
      </span>
    </span>
  </VBtn>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Mobile buttons.
 */
@Component({
  props: {
    /**
     * Button classString.
     */
    btnStyle: {
      type:     String,
      default:  'default',
      required: false,
      /**
       * Validator.
       */
      validator(value) {
        return [ 'default', 'border', 'round', 'round-big', 'icon', 'plain' ].indexOf(value) !== -1;
      },
    },
    absolutePosition: {
      type:     String,
      default:  null,
      required: false,
      /**
       * Validator.
       */
      validator(value) {
        return  value === 'bottom';
      },
    },
    href: {
      type:     String,
      default:  null,
      required: false,
    },
    square: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class MobileButton extends Vue {
  isIcon = false;

  get btnClass() {
    let classString = this.btnStyle;

    if (this.square) {
      classString += ' square';
    }

    return classString;
  }

  /**
   * btnTag.
   * Get tag for button element.
   */
  get btnTag() {
    if (this.href) {
      return 'a';
    }

    return 'button';
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/helpers.scss";
@import "@/style/variables.scss";

.v-btn.mobile-button {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
  font-family: $main-font-family;
  font-weight: 700;
  font-size: rem(14px);
  text-align: center;
  background: linear-gradient(180deg, $green-light 0%, $dark-green 100%);
  text-transform: uppercase;
  outline: none;
  border-radius: 2px;
  box-shadow: 0 -1px 4px 0 $black-light-transparent2;
  margin-left: 0;
  margin-right: 0;

  &.bottom,
  &.bottom:focus {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
  }

  .btn-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: $white;
  }

  .main-content {
    display: flex;
    align-items: center;
  }

  &.v-btn--disabled {
    opacity: .5;
  }

  &.border {
    border: 1px solid $green-color;
    box-shadow: 0 -1px 4px 0 $black-semi-transparent;
    background: transparent;

    .btn-content {
      color: $black;
    }
  }

  &.round {
    height: 34px;
    width: 68px;
    border-radius: 17px;
    min-width: auto;
    padding: 0;
  }

  &.round-big {
    border-radius: 25px;
  }

  &.icon {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    min-width: auto;
    background: transparent;
    box-shadow: none;
  }

  &.plain {
    background: transparent;
    margin: 0;
    box-shadow: none;

    .btn-content {
      color: #007AFF;
      font-size: rem(17px);
      letter-spacing: rem(-0.41px);
      text-transform: capitalize;
      font-weight: normal;
    }
  }

  &.square {
    border-radius: 0;
  }
}

.sub-text {
  color: $white;
  font-family: $main-font-family;
  font-size: rem(12px);
  font-style: italic;
  font-weight: 300;
  text-align: center;
  line-height: 1.2;
  margin-top: 2px;
  display: block;
  text-transform: none;

  &:empty {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileButton.vue